import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useAppSelector, useAppDispatch } from 'app/hooks'
import { selectIsQuotaExceedMofalOpen } from 'features/scheduledReport/selectors'
import { closeScheduledReportErrorModal } from 'features/scheduledReport/scheduledReportSlice'

const ErrorDialog = () => {
  const mode = useDisplayTheme() as Theme
  const { t } = useTranslation()
  const isOpen = useAppSelector(selectIsQuotaExceedMofalOpen)
  const dispatch = useAppDispatch()

  const handleClose = () => {
    dispatch(closeScheduledReportErrorModal())
  }

  return (
    <Dialog
      mode={mode}
      open={isOpen}
      onClose={handleClose}
      width="600px"
      maxHeight="85vh"
      isStretchedDivider>
      <Dialog.DialogTitle>{t('alert')}</Dialog.DialogTitle>
      <Dialog.DialogContent>{t('scheduledReportQuotaExceed')}</Dialog.DialogContent>
      <Dialog.DialogActions
        closeButtonProps={{
          children: t('ok'),
          onClick: handleClose
        }}
      />
    </Dialog>
  )
}

export default ErrorDialog
